/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowUiShareAImportIcon20Solid = forwardRef('ArrowUiShareAImportIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9 2a4 4 0 0 0-4 4v2.965A3.5 3.5 0 0 1 2 5.5V4.375a1 1 0 1 0-2 0V5.5a5.5 5.5 0 0 0 5 5.478V14a4 4 0 0 0 4 4h7a4 4 0 0 0 4-4V6a4 4 0 0 0-4-4H9Zm-4 8.978c.165.014.331.022.5.022h7.586l-2.043 2.043a1 1 0 0 0 1.414 1.414l2.866-2.866a2.25 2.25 0 0 0 0-3.182l-2.866-2.866a1 1 0 1 0-1.414 1.414L13.086 9H5.5a3.53 3.53 0 0 1-.5-.035v2.013Z" })));
});
